import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

const loadBundleDefinitions = () => import("@workflows/bundles/definitions");
const loadBundleDefinitionDetails = () => import("@workflows/bundles/definitions/definition-details/DefinitionDetails");
const loadBundleDefinitionFormLayout = () =>
  import("@workflows/bundles/definitions/definition-layout/BundleDefinitionFormLayout");
const loadBundleDefinitionGridLayout = () =>
  import("@workflows/bundles/definitions/definition-layout/BundleDefinitionGridLayout");
const loadBundleDefinitionLayout = () =>
  import("@workflows/bundles/definitions/definition-layout/BundleDefinitionLayout");
const loadBundleCreateAndEditPanel = () =>
  import("@workflows/bundles/definitions/definition-panels/BundleCreateAndEditPanel");
const loadImportBundleDefinition = () => import("@workflows/bundles/definitions/import-definition/ImportDefinition");
const loadImportAncillaryDefinitions = () =>
  import("@workflows/bundles/definitions/import-definition/ancillary/ImportDefinition");

export const BundleDefinitionsLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitionLayout } = await loadBundleDefinitionLayout();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <BundleDefinitionLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsGridLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitionGridLayout } = await loadBundleDefinitionGridLayout();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES}>
      <BundleDefinitionGridLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitions } = await loadBundleDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <BundleDefinitions tab={0} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsRTFLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitions } = await loadBundleDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <BundleDefinitions tab={0} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsNonRTFLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitions } = await loadBundleDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <BundleDefinitions tab={1} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsFormLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitionFormLayout } = await loadBundleDefinitionFormLayout();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES}>
      <BundleDefinitionFormLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsCreateLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleCreateAndEditPanel } = await loadBundleCreateAndEditPanel();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <BundleCreateAndEditPanel type="create" />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};

export const BundleDefinitionsEditLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleCreateAndEditPanel } = await loadBundleCreateAndEditPanel();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES}>
      <BundleCreateAndEditPanel type="edit" />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsDuplicateLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleCreateAndEditPanel } = await loadBundleCreateAndEditPanel();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES}>
      <BundleCreateAndEditPanel type="duplicate" />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsImportLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: ImportBundleDefinition } = await loadImportBundleDefinition();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <ImportBundleDefinition />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const ServiceDefinitionsImportLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: ImportAncillaryDefinitions } = await loadImportAncillaryDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <ImportAncillaryDefinitions />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const BundleDefinitionsDetailsLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleDefinitionDetails } = await loadBundleDefinitionDetails();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_DEFINITIONS}>
      <BundleDefinitionDetails />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};
